import { render, staticRenderFns } from "./BlogMiniCard.vue?vue&type=template&id=c64a53f8&scoped=true&"
import script from "./BlogMiniCard.vue?vue&type=script&lang=js&"
export * from "./BlogMiniCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogMiniCard.vue?vue&type=style&index=0&id=c64a53f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64a53f8",
  null
  
)

export default component.exports